const colors={
    blue: '#5543d1',
    indigo:'#6610f2',
    purple: '#6f42c1',
    pink: '#e83e8c',
    red: '#ff586e',
    orange: '#ff8853',
    yellow: '#ffa808',
    green: '#029e76',
    teal: '#20c997',
    cyan: '#17a2b8',
    white: '#fff',
    gray: '#6c757d',
    grayDark: '#343a40',
    primary: '#f01f75',
    secondary: '#111942',
    success: '#029e76',
    info: '#00aeff',
    warning: '#fea500',
    danger: '#ff5269',
    light: '#faf8f2',
    dark: '#262f5a',
}
export default colors